module.exports = __webpack_public_path__ + "img/high_income.d5fcd8b6.svg";